import {
  FETCH_JOURNAL_CONTENT_API_START,
  FETCH_JOURNAL_CONTENT_API_SUCCESS,
  FETCH_JOURNAL_CONTENT_API_FAIL,
} from './action';

const initialState = {
  items: [],
  period: null,
  rangeFrom: null,
  rangeTo: null,
  metricName: null,
  fromCache: false,
  isLoading: false,
  isInitial: false,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_JOURNAL_CONTENT_API_START:
    // При смене периода сбрасываем старые items, чтобы пользователь видел
    // явное состояние загрузки, а не «залипшие» данные предыдущего периода.
    return {
      ...state,
      items: [],
      isLoading: true,
      error: null,
      period: payload?.period ?? state.period,
    };
  case FETCH_JOURNAL_CONTENT_API_SUCCESS:
    return {
      ...state,
      items: Array.isArray(payload.data?.items) ? payload.data.items : [],
      period: payload.data?.period ?? payload.period,
      rangeFrom: payload.data?.rangeFrom ?? null,
      rangeTo: payload.data?.rangeTo ?? null,
      metricName: payload.data?.metricName ?? null,
      fromCache: Boolean(payload.data?.fromCache),
      isLoading: false,
      isInitial: true,
      error: null,
    };
  case FETCH_JOURNAL_CONTENT_API_FAIL:
    return {
      ...state,
      items: [],
      isLoading: false,
      isInitial: true,
      error: payload,
    };
  default:
    return { ...state };
  }
};
